import { isBoolean, isEmpty, isUndefined } from 'lodash';
import { useContext } from 'react';

import { FeatureContext } from '../../components/feature-provider';
import { logger } from '../../utils/logger';

const useFeature = key => {
  const flags = useContext(FeatureContext);

  if (!flags) {
    throw new Error('useFeature must be used within a FeatureProvider');
  }

  const flag = flags[key];

  if (isUndefined(flag)) {
    // Don't show this warning if the flags are still loading
    if (flags.length !== 0) {
      logger.error(`Feature Flag ${key} is undefined and will be set to false`);
    }
    return false;
  }

  if (!isBoolean(flag) && isEmpty(flag)) {
    return false;
  }

  return flag;
};

export { useFeature };
